import {AfterViewInit, Component, EventEmitter, Input, Output} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

declare var $: any;
//declare var moment: any;

@Component({
    selector: 'calendar',
    templateUrl: './c.component.html',
    styleUrls: ['./c.component.css'],
    standalone: false
})
export class CalendarComponent implements AfterViewInit {
  translate: TranslateService;


  //private format:string = 'DD.MM.YYYY H:mm';

  @Input('date')
  public date = null;
  @Output()
  dateChange: EventEmitter<number> = new EventEmitter();

  @Input()
  public clear: boolean = false;
  @Input()
  public disabled: boolean = false;

  @Input()
  public name: string;
  @Input()
  public format: string = '%0D.%0M.%0Y';

  constructor(translate: TranslateService) {
    this.translate = translate;
  }

  //@Output()
  //public onStartDateChanged: EventEmitter<number> = new EventEmitter<number>();
  //@Output()
  //public onEndDateChanged: EventEmitter<number> = new EventEmitter<number>();

  protected calendarElement = null;

  ngAfterViewInit(): void {
    this.InitCalendar();
  }

  protected InitCalendar()
  {
    if (/*this.readonly || */this.calendarElement)
      return;

    this.calendarElement = $('#' + this.name);
    this.calendarElement.daterangepicker({
      timePicker: true,
      singleDatePicker: true,
      //timePickerIncrement: 5,
      timePicker24Hour: true,
      timePickerSeconds: true,
      autoUpdateInput: false,
      //startDate: dtFrom,
      //endDate: dtTill,
      locale: {
        // format: this.format.replace("%0D", "DD").replace("%0M", "MM").replace("%0Y", "YYYY").replace("%0H", "HH").replace("%0m", "mm").replace("%0s", "ss"),
        separator: " - ",
        applyLabel: this.translate.instant("Apply"),
        cancelLabel: this.translate.instant("Cancel"),
        customRangeLabel: this.translate.instant("Custom interval"),
        weekLabel: "W",
        daysOfWeek: [
          this.translate.instant("Sn"),
          this.translate.instant("Mn"),
          this.translate.instant("Tu"),
          this.translate.instant("Wd"),
          this.translate.instant("Th"),
          this.translate.instant("Fr"),
          this.translate.instant("St")
        ],
        monthNames: [
          this.translate.instant("January"),
          this.translate.instant("February"),
          this.translate.instant("March"),
          this.translate.instant("April"),
          this.translate.instant("May"),
          this.translate.instant("June"),
          this.translate.instant("July"),
          this.translate.instant("August"),
          this.translate.instant("September"),
          this.translate.instant("October"),
          this.translate.instant("November"),
          this.translate.instant("December")
        ],
        firstDay: 1
      }
    }, (start, end, label) => {
        //this.onStartDateChanged.emit(+start.format('x'));
        //this.onEndDateChanged.emit(+start.format('x'));
        this.date = start.toDate().getTime();
        this.dateChange.emit(this.date);
    });

    if (this.date)
      this.calendarElement.data('daterangepicker').setStartDate(new Date(this.date));
  }

  public onClick()
  {
    if (this.calendarElement && !this.disabled)
      this.calendarElement.data('daterangepicker').show();
  }
  public onClear()
  {
    if (this.calendarElement)
      this.calendarElement.data('daterangepicker').hide();

    this.date = 0;
    this.dateChange.emit(this.date);

    return false;
  }
}

